import styled from "styled-components";

export const Input = styled.input`
  width: 20rem;
  border: solid 1px silver;
  box-shadow: inset 6px 6px 6px -8px silver;
  font-size: 1rem;
  padding: 0.5rem 0.5rem;
  border-radius: 0;
`;
